import React from 'react';

/**
 * Retorna la etiqueta de estado normalizada para una transacción.
 */
export const getEstadoEtiqueta = (transaccion) => {
    if (transaccion.transaction_type?.toLowerCase() === "devolucion" && transaccion.transaction_status === "aprobada") {
      return "Devolucion";
    }
    switch (transaccion.transaction_status) {
      case "aprobada":
        return "Aprobada";
      case "rechazadaRiesgo":
      case "rechazadaProsa":
      case "rechazada":
        return "Rechazada";
      default:
        return transaccion.transaction_status;
    }
};

/**
 * Renderiza un badge estilizado para el estado de una transacción.
 */
export const renderEstado = (estado) => {
    if (!estado) {
      return <span>NULO</span>;
    }
    const isDevolucion = estado.toLowerCase() === "devolucion";
    const isApproved = estado.toLowerCase() === "aprobada";

    let iconClass;
    let backgroundColor;

    if (isDevolucion) {
      iconClass = "fa-undo";
      backgroundColor = "#FCAD2A"; // Naranja
    } else {
      iconClass = isApproved ? "fa-check-circle" : "fa-times-circle";
      backgroundColor = isApproved ? "#0E9600" : "#FF4444"; // Verde o rojo
    }

    return (
      <span
        style={{
          display: "inline-block",
          padding: "5px 10px",
          color: "white",
          backgroundColor,
          borderRadius: "8px",
          fontSize: "12px",
          fontWeight: "bold",
          textAlign: "center",
        }}
      >
        <i className={`fa ${iconClass}`} style={{ marginRight: "5px" }}></i>
        {estado}
      </span>
    );
};
